function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import * as logistics from '@/api/logistics';
import * as customerOrderApi from '@/api/customerOrderApi.js';
import throttle from '@/utils/throttle';
import * as suplierCouponsApi from '@/api/suplierCouponsApi.js';
export default {
  data: function data() {
    return {
      loading: false,
      visible: false,
      goodsId: '',
      pram: {},
      initloading: false,
      addresData: [],
      cosotmerOption: [],
      // 归属客户
      userLists: []
    };
  },
  mounted: function mounted() {
    this.getCityList();
  },
  methods: {
    throttle: throttle,
    openInit: function openInit(row) {
      var _this = this;
      this.visible = true;
      this.initloading = true;
      this.pram = {
        supplierId: row.id
      };
      suplierCouponsApi.getCities(row.id).then(function (res) {
        setTimeout(function () {
          _this.initloading = false;
        }, 1500);
        _this.pram = _objectSpread(_objectSpread({}, res || {}), _this.pram);
      }).catch(function (err) {});
    },
    handerSubmit: function handerSubmit() {
      var _this2 = this;
      this.loading = true;
      suplierCouponsApi.saveCities(this.pram).then(function (data) {
        _this2.$message.success('操作成功');
        _this2.loading = false;
        _this2.visible = false;
        _this2.$emit('doRefresh');
      }).catch(function () {
        _this2.loading = false;
      });
    },
    closeEdit: function closeEdit() {
      this.visible = false;
    },
    getCityList: function getCityList() {
      var _this3 = this;
      this.addresData = [];
      logistics.cityListTree().then(function (res) {
        _this3.addresData = res || [];
      });
    }
  }
};